// Mashi J — single source of truth for audio + links.
// Paste the real URLs here; the whole site reads from this file.

export const AUDIO_PREVIEW_SRC = "/audio/the-way-you-love-preview-v3.mp3";

export const STREAMING_LINKS = {
    spotify: "#",
    apple: "#",
    youtube: "#",
};

export const MUSIC_RELEASE = {
    title: "The Way You Love",
    artwork: "/images/music-new-single.jpg",
    href: "#",
};

export const SOCIAL_LINKS = [
    { name: "Instagram", href: "https://instagram.com/mochi_mashi" },
    { name: "TikTok", href: "https://tiktok.com/@mashijay98" },
    { name: "YouTube", href: "https://youtube.com/@mashijsings" },
];
